// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  name: __t.string(),
  kind: __t.string(),
  config: __t.string(),
  spaceId: __t.string().name("space_id"),
  scopeId: __t.string().name("scope_id"),
  allowWrite: __t.bool().name("allow_write"),
  hasSecret: __t.bool().name("has_secret"),
  lastError: __t.string().name("last_error"),
  createdByUserId: __t.string().name("created_by_user_id"),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
